﻿import * as types from './mutation-types';
import * as addressService from '../../../api/addresslookup';
import basketService from '../../../api/basket';
import productService from '../../../api/products';

export const getAddressSuggestions = ({ commit, state }, params) => {
    addressService.getSuggestions(
        params.query, params.caretPosition || 0, params.hasStreetName || false, params.addressId,
        (suggestions) => commit(types.ADDRESS_LOOKUP_SUCCESS, suggestions),
        (e) => console.log(e)
    );
};

export const resetAddressSuggestions = ({ commit }) => {
    commit(types.RESET_ADDRESS_SUGGESTIONS);
};

export const resetSelectedAddress = ({ commit }) => {
    commit(types.RESET_SELECTED_ADDRESS);
};

export const resetAddressLookup = ({ commit }) => {
    commit(types.RESET_ADDRESS_LOOKUP);
};

export const pickAddressSuggestion = ({ commit }, address) => {
    if (!address || !address.postCode) {
        commit(types.ADDRESS_LOOKUP_FAILURE);
        return;
    }
    commit(types.STORE_SELECTED_ADDRESS, address);
    commit(types.RESET_ADDRESS_SUGGESTIONS);
};

export const beginProductSearch = ({ commit, state }) => {
    commit(types.BEGIN_PRODUCT_SEARCH);
};

export const lookupProducts = ({ commit, dispatch, state }, blockId) => {
    commit(types.BEGIN_PRODUCT_SEARCH);
    commit(types.SET_ADDRESS_QUERY, state.addresslookup.selectedAddress.friendly);
    productService.getProducts(
        blockId,
        state.addresslookup.selectedAddress,
        (products) => {
            commit(types.STORE_AVAILABLE_PRODUCTS, products);
            dispatch('updateBasketPrice'); //replace with selectvariant and codes
        },
        (err) => console.log(err));
};

export const selectVariant = ({ commit, dispatch, state }, code) => {
    let products = state.products.available;

    for (let i = 0; i < products.length; i++) {
        if (products[i].code === code.productCode) {
            for (let j = 0; j < products[i].variants.length; j++) {
                if (products[i].variants[j].code === code.variantCode) {
                    code.speedDown = products[i].variants[j].speedDown;
                    code.speedUp = products[i].variants[j].speedUp;
                    code.blockId = products[i].blockId;
                }
            }
        }
    }

    commit(types.SELECT_VARIANT, code);
    dispatch('updateBasketPrice');
};

export const addToBasket = ({ commit, dispatch, state }, nextPageUrl) => {
    
    const productcode = state.products.selectedProduct;
    const variant = state.products.selectedVariant;
    const address = state.addresslookup.selectedAddress;
    var vasArray = [];
    for (let i = 0; i < state.vas.selectedVas.length; i++) {
        vasArray.push(state.vas.selectedVas[i].code);
    }

    const installationFeeCode = state.installationFeeCode;

    const activationFeeCode = state.activationFeeCode;

    const paymentFeeCode = state.paymentFeeCode;

    const speedUp = state.products.speedUp;

    const speedDown = state.products.speedDown;

    const vendor = state.products.vendor;

    var isBoost = false;
    const product = {
        productcode: productcode,
        isBoost: isBoost,
        variant: variant,
        additionalvariantcodes: vasArray,
        speedUp: speedUp,
        speedDown: speedDown,
        vendor: vendor
    };

    const data = {
        installationFeeCode: installationFeeCode,
        activationFeeCode: activationFeeCode,
        paymentFeeCode: paymentFeeCode,
        product: product,
        address: address
    };

    basketService.addToBasket(
        data,
        () => {
            if (nextPageUrl) {
                window.location.href = nextPageUrl;
            }
        });
};

export const selectVAS = ({ commit, dispatch, state }, code) => {
    let newNumOfVas = state.vas.selectedVas.length;
    let commitVas = true;

    state.index=code.pointer;

    if (newNumOfVas === state.vas.maxNumberOfVas) {
        dispatch('showVasSelectionModal', true);
    } else {
        let selectionOfLimitedVas = [];
        selectionOfLimitedVas.push(code.vasGroup);

        const findDuplicatedVas = selectedVasArr => selectedVasArr.filter((vas, index) => selectedVasArr.indexOf(vas) !== index);

        state.vas.selectedVas.forEach(vas => {
            selectionOfLimitedVas.push(vas.vasGroup);
            const duplicatedVas = findDuplicatedVas(selectionOfLimitedVas);
            if (duplicatedVas.length > 0) {
                commitVas = false;
                state.vas.nameOfLimitVas = duplicatedVas[0];
                dispatch('showVasLimitModal', true);
            }
        });
    }

    if (newNumOfVas < state.vas.maxNumberOfVas && commitVas) {
        commit(types.SELECT_VAS, code);
        newNumOfVas += 1;
    }
    if (state.products.selectedProduct && state.products.selectedProduct !== '') {
        const products = state.products.available;

        let downSpeed = -1;
        let upSpeed = -1;
        for (let i = 0; i < products.length; i++) {
            if (products[i].code === state.products.selectedProduct) {
                for (let j = 0; j < products[i].variants.length; j++) {
                    if (products[i].variants[j].code === state.products.selectedVariant) {
                        downSpeed = products[i].variants[j].speedDown;
                        upSpeed = products[i].variants[j].speedUp;
                    }
                }
            }
        }

        for (let i = 0; i < products.length; i++) {
            if (products[i].code === state.products.selectedProduct) {
                for (let j = 0; j < products[i].variants.length; j++) {
                    if (products[i].variants[j].speedDown === downSpeed &&
                        products[i].variants[j].speedUp === upSpeed &&
                        products[i].variants[j].numberOfVas === newNumOfVas) {
                        const ifc = state.installationFeeCode;
                        const afc = state.activationFeeCode;
                        const pfc = state.paymentFeeCode;
                        let codes = { installationFeeCode: ifc, activationFeeCode: afc, paymentFeeCode: pfc, productCode: products[i].code, variantCode: products[i].variants[j].code, numberOfVas: newNumOfVas, vendor: products[i].variants[j].vendor};
                        dispatch('selectVariant', codes);
                    }
                }
            }
        }
    }
    dispatch('updateBasketPrice');
};

export const deselectVAS = ({ commit, dispatch, state }, code) => {
    let newNumOfVas = Math.max(1, state.vas.selectedVas.length - 1);

    commit(types.DESELECT_VAS, code);
    //TODO: To be refactored
    document.getElementById("togglebutton"+code.pointer).checked=false;
    if (state.products.selectedProduct && state.products.selectedProduct !== '') {
        let products = state.products.available;

        let downSpeed = -1;
        let upSpeed = -1;
        for (let i = 0; i < products.length; i++) {
            if (products[i].code === state.products.selectedProduct) {
                for (let j = 0; j < products[i].variants.length; j++) {
                    if (products[i].variants[j].code === state.products.selectedVariant) {
                        downSpeed = products[i].variants[j].speedDown;
                        upSpeed = products[i].variants[j].speedUp;
                    }
                }
            }
        }

        for (let i = 0; i < products.length; i++) {
            if (products[i].code === state.products.selectedProduct) {
                for (let j = 0; j < products[i].variants.length; j++) {
                    if (products[i].variants[j].speedDown === downSpeed &&
                        products[i].variants[j].speedUp === upSpeed &&
                        products[i].variants[j].numberOfVas === newNumOfVas) {
                        const ifc = state.installationFeeCode;
                        const afc = state.activationFeeCode;
                        const pfc = state.paymentFeeCode;
                        let codes = { installationFeeCode: ifc, activationFeeCode: afc, paymentFeeCode: pfc, speedUp: products[i].variants[j].speedUp, speedDownload: products[i].variants[j].speedDown, productCode: products[i].code, variantCode: products[i].variants[j].code, numberOfVas: newNumOfVas, vendor: products[i].variants[j].vendor};
                        dispatch('selectVariant', codes);
                    }
                }
            }
        }
    }
    dispatch('updateBasketPrice');
};

export const invalidAddressPicked = ({ commit, state }, query) => {
    commit(types.SET_ADDRESS_QUERY, query);
    commit(types.ADDRESS_LOOKUP_FAILURE);
};

export const updateBasketPrice = ({ commit, state }) => {
    basketService.getTotalOfferingPrice(
        state.products.selectedVariant,
        state.vas.selectedVas,
        state.products.blockId,
        (res) => commit(types.UPDATE_CART_PRICE, { price: res.data.price, bindingCost: res.data.bindingCost } ),
        () => commit(types.UPDATE_CART_PRICE, ''));

};

export const showVasSelectionModal = ({ commit, dispatch, state }, bool) => {
    if (!bool) {
        if (state.index) {
            document.getElementById("togglebutton" + state.index).checked = false;
        }
    }
    commit(types.SHOW_VAS_SELECTION_MODAL, bool)
};

export const setMaxNumberOfVas = ({ commit, dispatch, state }, number) => {
    commit(types.SET_MAX_NUMBER_OF_VAS, number)
};

export const showAddressMissingModal = ({ commit, dispatch, state }, bool) => {
    commit(types.SHOW_ADDRESS_MISSING_MODAL, bool)
};

export const showVasLimitModal = ({ commit, dispatch, state }, bool) => {
    if (!bool) {
        if (state.index) {
            document.getElementById("togglebutton" + state.index).checked = false;
        }
    }
    commit(types.SHOW_VAS_LIMIT_MODAL, bool)
};